// import { useAuth } from "../../context/AuthContext";
// import { useNavigate } from "react-router-dom";
// import SearchEngine from "../SearchEngine/SearchEngine";

// const Dashboard = () => {
//   const { user } = useAuth();
//   const navigate = useNavigate();

//   const handleLogout = async () => {
//     await fetch(`${process.env.REACT_APP_BACKEND_URL}/auth/logout`, {
//       credentials: "include",
//     });
//     navigate("/");
//   };

//   return (
//     <div className="dashboard-container">
//       <nav className="navbar">
//         <div className="navbar-brand">CrowsNest</div>
//         <div className="navbar-user">
//           <img
//             src={user?.profilePic}
//             alt="Profile"
//             className="user-avatar"
//             referrerPolicy="no-referrer"
//           />
//           <span className="user-name">{user?.name}</span>
//           <button className="logout-button" onClick={handleLogout}>
//             Logout
//           </button>
//         </div>
//       </nav>
//       <div className="dashboard-content">
//         <h2>Welcome, {user?.name}</h2>
//         <p>Email: {user?.email}</p>
//         <SearchEngine />
//       </div>
//     </div>
//   );
// };

// export default Dashboard;

// import { useAuth } from "../../context/AuthContext";
// import { useNavigate } from "react-router-dom";
// import SearchEngine from "../SearchEngine/SearchEngine";
// import { useState } from "react";
// import "./Dashboard.css";

// const Dashboard = () => {
//   const { user } = useAuth();
//   const navigate = useNavigate();
//   const [showDropdown, setShowDropdown] = useState(false);

//   // Dashboard.js - Updated logout handler
// const handleLogout = async () => {
//   try {
//     const response = await fetch(
//       `${process.env.REACT_APP_API_URL}/auth/logout`,
//       {
//         method: "GET",
//         credentials: "include",
//         headers: {
//           "Content-Type": "application/json",
//         },
//       }
//     );

//     if (!response.ok) throw new Error("Logout failed");

//     window.location.href = "/";
//   } catch (error) {
//     console.error("Logout error:", error);
//   }
// };

//   const getTimeBasedGreeting = () => {
//     const hour = new Date().getHours();
//     if (hour < 12) return "🌞 Good Morning";
//     if (hour < 18) return "🌤️ Good Afternoon";
//     return "🌆 Good Evening";
//   };

//   const handleSaved = () => {
//     navigate("/saved-chats");
//   };
//   const handleHome = () => {
//     navigate("/dashboard");
//   };

//   return (
//     <div className="dashboard">
//       <nav className="dashboard__navbar">
//         <div className="dashboard__brand" onClick={handleHome}>
//           CrowsNest
//         </div>
//         <div className="dashboard__nav-links">
//           <button className="nav-buttons" onClick={handleHome}>
//             Home
//           </button>
//           <button className="nav-buttons" onClick={handleSaved}>
//             Saved
//           </button>
//           {/* <button className="nav-buttons">Billings</button> */}
//           <div
//             className="dashboard__profile"
//             onClick={() => setShowDropdown(!showDropdown)}
//           >
//             <img
//               src={user?.profilePic}
//               alt="Profile"
//               className="dashboard__avatar"
//               referrerPolicy="no-referrer"
//             />
//             {showDropdown && (
//               <div className="dashboard__dropdown">
//                 <div className="dashboard__user-info">
//                   <p className="dashboard__user-name">{user?.name}</p>
//                   <p className="dashboard__user-email">{user?.email}</p>
//                 </div>
//                 <button
//                   className="dashboard__logout-btn"
//                   onClick={handleLogout}
//                 >
//                   Logout
//                 </button>
//               </div>
//             )}
//           </div>
//         </div>
//       </nav>

//       <div className="dashboard__content">
//         {/* <h1 className="dashboard__welcome">
//           Welcome Back, <span className="user-name">{user?.name}</span>
//         </h1> */}
//         <h1 className="dashboard__welcome">
//           {getTimeBasedGreeting()},{" "}
//           <span className="user-name">{user?.name}</span>
//         </h1>
//         <div className="dashboard__search-container">
//           <SearchEngine />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Dashboard;

// Latest

import React, { useState, useEffect, useRef } from "react";
import { useAuth } from "../../context/AuthContext";
import {
  useNavigate,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import { toast } from "react-toastify";
import SearchEngine from "../SearchEngine/SearchEngine";
import Saved from "../Saved/Saved";
import "./Dashboard.css";
import logoImage from "../SearchEngine/image.png";

const Dashboard = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [showProfileDropdown, setShowProfileDropdown] = useState(false);
  const [greeting, setGreeting] = useState("");
  const [greetingEmoji, setGreetingEmoji] = useState("");
  const [isNameVisible, setIsNameVisible] = useState(false);
  const profileDropdownRef = useRef(null);

  // Generate greeting based on time of day
  useEffect(() => {
    const currentHour = new Date().getHours();
    let greetingText = "";
    let emoji = "";

    if (currentHour >= 5 && currentHour < 12) {
      greetingText = "Good Morning";
      emoji = "🌞";
    } else if (currentHour >= 12 && currentHour < 18) {
      greetingText = "Good Afternoon";
      emoji = "🌤️";
    } else {
      greetingText = "Good Evening";
      emoji = "🌆";
    }

    setGreetingEmoji(emoji);
    setGreeting(greetingText);

    // Add a slight delay before showing the name for animation
    setTimeout(() => {
      setIsNameVisible(true);
    }, 300);
  }, [user]);

  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        profileDropdownRef.current &&
        !profileDropdownRef.current.contains(event.target)
      ) {
        setShowProfileDropdown(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Handle logout
  // const handleLogout = async () => {
  //   try {
  //     await logout();
  //     setShowProfileDropdown(false);
  //     toast.success("Logged out successfully");
  //     navigate("/");
  //   } catch (error) {
  //     console.error("Logout error:", error);
  //     toast.error("Failed to logout");
  //   }
  // };

  const handleLogout = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/auth/logout`,
        {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) throw new Error("Logout failed");

      window.location.href = "/";
    } catch (error) {
      console.error("Logout error:", error);
    }
  };

  // Navigate to pages
  const navigateToHome = () => {
    navigate("/dashboard");
  };

  const navigateToSaved = () => {
    navigate("/saved-chats");
  };

  // Get username for display
  const getUserDisplayName = () => {
    if (user && user.name) {
      return user.name;
    }
    return "there";
  };

  return (
    <div className="dashboard">
      {/* Header Component */}
      <div className="app-header">
        <div className="logo-container">
          <div className="logo">
            <img src={logoImage} alt="CrowsNest Logo" className="logo-image" />
          </div>
        </div>
        <div className="nav-container">
          <nav className="main-nav">
            <a
              onClick={navigateToHome}
              className={`nav-link ${
                location.pathname === "/dashboard" ? "active" : ""
              }`}
              style={{ cursor: "pointer" }}
            >
              Home
            </a>
            <a
              onClick={navigateToSaved}
              className={`nav-link ${
                location.pathname === "/saved-chats" ? "active" : ""
              }`}
              style={{ cursor: "pointer" }}
            >
              Saved
            </a>
            <div className="user-profile" ref={profileDropdownRef}>
              <div
                className="profile-dropdown-trigger"
                onClick={() => setShowProfileDropdown(!showProfileDropdown)}
              >
                <div className="profile-image">
                  {user && user?.profilePic ? (
                    <img className="dashboad__avatar" src={user?.profilePic} alt={user?.name || "User"} />
                  ) : (
                    <div className="profile-placeholder">
                      {user && user?.name
                        ? user?.name.charAt(0).toUpperCase()
                        : "U"}
                    </div>
                  )}
                </div>
              </div>

              {showProfileDropdown && (
                <div className="profile-menu">
                  <div className="profile-info">
                    <div className="profile-name">
                      {user ? user?.name : "User"}
                    </div>
                    <div className="profile-email">
                      {user ? user.email : ""}
                    </div>
                  </div>
                  <div className="profile-divider"></div>
                  <div className="profile-menu-items">
                    <button className="logout-button" onClick={handleLogout}>
                      Logout
                    </button>
                  </div>
                </div>
              )}
            </div>
          </nav>
        </div>
      </div>

      <div className="hero-greeting-section">
        <div className="hero-greeting-container">
          <span className="greeting-emoji">{greetingEmoji}</span>
          <h1 className="hero-greeting-text">
            <span className="greeting-prefix">{greeting},</span>
            <span className={`greeting-name ${isNameVisible ? "visible" : ""}`}>
              {getUserDisplayName()}
            </span>
          </h1>
        </div>
        <p className="greeting-subtitle">What would you like to know today?</p>
      </div>

      {/* Page Content - Will be rendered based on current route */}
      <Routes>
        <Route path="/" element={<SearchEngine />} />
        <Route path="/saved-chats" element={<Saved />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  );
};

export default Dashboard;
